import React, { useEffect, useState } from "react";
import axios from "axios";
import { BellRing, Trash2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const tone = { Waiting: "bg-amber-100 text-amber-800", Held: "bg-emerald-600 text-white", Notified: "bg-emerald-100 text-emerald-800", Booked: "bg-emerald-100 text-emerald-800", Expired: "bg-gray-100 text-gray-500", Removed: "bg-gray-100 text-gray-500" };

export default function PatientWaitlist({ onBookHeld }) {
  const [entries, setEntries] = useState([]);
  const load = () => axios.get(`${API}/waitlist/mine`, { withCredentials: true }).then((r) => setEntries(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (id) => { await axios.delete(`${API}/waitlist/${id}`, { withCredentials: true }); load(); };
  const active = entries.filter((e) => !["Removed", "Booked", "Expired"].includes(e.status));
  if (active.length === 0) return null;

  return (
    <div className="bg-white p-6 rounded-3xl border border-amber-200 shadow-sm space-y-3" data-testid="patient-waitlist">
      <h3 className="font-serif-luxury text-xl font-bold text-gray-900 flex items-center gap-2"><BellRing className="w-5 h-5 text-amber-500" /> Slot waitlist alerts</h3>
      <div className="space-y-2">
        {active.map((w) => (
          <div key={w.id} data-testid={`waitlist-entry-${w.id}`} className="p-3 bg-[#FBF9F4] rounded-2xl border border-gray-200 flex flex-col sm:flex-row sm:items-center justify-between gap-2 text-xs">
            <div>
              <p className="font-bold text-gray-900">{w.doctor_name} <span className="text-gray-500 font-normal">({w.specialty})</span></p>
              <p className="text-gray-600">{w.date} at <b>{w.time_slot}</b> • position #{w.position}</p>
              {w.status === "Notified" && <p className="text-emerald-700 font-semibold">This slot freed up — book it now from the Specialists page.</p>}
              {w.status === "Held" && (
                <div className="flex flex-wrap items-center gap-2 mt-1">
                  <p className="text-emerald-800 font-bold" data-testid={`waitlist-hold-${w.id}`}>Reserved for you until {new Date(w.hold_until).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</p>
                  {onBookHeld && <button onClick={() => onBookHeld({ id: w.doctor_id, name: w.doctor_name, specialty: w.specialty, _lookup: true, _prefill: { date: w.date, slot: w.time_slot } })} data-testid={`waitlist-book-${w.id}`} className="px-3 py-1 bg-[#0D3B2E] text-white rounded-lg text-[11px] font-bold">Book this slot now</button>}
                </div>
              )}
            </div>
            <div className="flex items-center gap-2">
              <span data-testid={`waitlist-status-${w.id}`} className={`px-2 py-0.5 rounded text-[10px] font-bold ${tone[w.status]}`}>{w.status}</span>
              <button onClick={() => remove(w.id)} data-testid={`waitlist-remove-${w.id}`} className="text-gray-400 hover:text-rose-600"><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
